
export const URL_Clinic = (`${process.env.REACT_APP_HOST}/clinic`)
export const URL_ClinicMinimal = (`${process.env.REACT_APP_HOST}/clinic/minimal`)
export const URL_Clinic_Filter = (`${process.env.REACT_APP_HOST}/clinic/filter`)
export const URL_HealthPlanClinic = (`${process.env.REACT_APP_HOST}/healthplanclinic`)
export const URL_ConfirmRegistrationEmail = (`${process.env.REACT_APP_HOST}/confirmregistrationemail`)